import { apiV1 } from './apiClient';

/**
 * Servicio para gestión de valores de campos dinámicos en órdenes
 * Consume endpoints de backend/src/routes/v1/valoresCamposRoutes.js
 */
const valoresCamposApi = {
  /**
   * GET /api/v1/valores-campos/orden/:idOrden
   * Obtener todos los valores de campos de una orden específica
   * @param {number} idOrden - ID de la orden de servicio
   * @returns {Promise<Array>} Array de valores con info del campo
   */
  getValoresPorOrden: async (idOrden) => {
    const response = await apiV1.get(`/valores-campos/orden/${idOrden}`);
    return response.data;
  },

  /**
   * POST /api/v1/valores-campos
   * Guardar o actualizar valor de un campo para una orden
   * @param {Object} valorData - Datos del valor
   * @param {number} valorData.id_orden_servicio - ID de la orden
   * @param {number} valorData.id_campo - ID del campo
   * @param {string} [valorData.valor_texto] - Valor si es tipo texto/email/telefono/url/textarea
   * @param {number} [valorData.valor_numerico] - Valor si es tipo numero
   * @param {string} [valorData.valor_fecha] - Valor si es tipo fecha (ISO string)
   * @param {boolean} [valorData.valor_booleano] - Valor si es tipo boolean
   * @param {Object} [valorData.valor_json] - Valor si es tipo select/archivo
   * @returns {Promise<Object>} Valor guardado/actualizado
   */
  saveValor: async (valorData) => {
    const response = await apiV1.post('/valores-campos', valorData);
    return response.data;
  },

  /**
   * POST /api/v1/valores-campos/batch
   * Guardar múltiples valores de campos a la vez
   * @param {Object} batchData - Datos del batch
   * @param {number} batchData.id_orden_servicio - ID de la orden
   * @param {Array<Object>} batchData.valores - Array de valores a guardar
   * @param {number} batchData.valores[].id_campo - ID del campo
   * @param {*} batchData.valores[].valor_* - Valor según tipo de campo
   * @returns {Promise<Object>} Resultado con valores guardados y errores si hay
   */
  saveValoresBatch: async (batchData) => {
    const response = await apiV1.post('/valores-campos/batch', batchData);
    return response.data;
  },

  /**
   * POST /api/v1/valores-campos/validar
   * Validar que todos los campos obligatorios de un estado estén completos
   * @param {Object} validacionData - Datos de validación
   * @param {number} validacionData.id_orden_servicio - ID de la orden
   * @param {number} validacionData.id_estado - ID del estado a validar
   * @returns {Promise<Object>} Resultado de validación { valido: boolean, camposFaltantes: Array }
   */
  validarCamposObligatorios: async (validacionData) => {
    const response = await apiV1.post('/valores-campos/validar', validacionData);
    return response.data;
  }
};

export default valoresCamposApi;
